import React from 'react';
import PropTypes from 'prop-types';

export const SeatedContext = React.createContext(null);

export function SeatedContextProvider({ children }) {
    let [seatedContext, setContext] = React.useState({
        inventory: null,
        contingent: null,
        inventories: null,
        contingents: null
    });

    const setValue = React.useCallback((name, value) => {
        setContext(ctx => {
            const newContext = { ...ctx };
            newContext[name] = value;
            return newContext;
        });
    }, []);

    const setInventory = React.useCallback(
        model => {
            if (seatedContext.inventory && model.uuid === seatedContext.inventory.uuid) {
                return;
            }

            setValue('inventory', model);
        },
        [seatedContext, setValue]
    );

    const setContingent = React.useCallback(
        model => {
            if (seatedContext.contingent && model.uuid === seatedContext.contingent.uuid) {
                return;
            }

            setValue('contingent', model);
        },
        [seatedContext, setValue]
    );

    return (
        <SeatedContext.Provider
            value={{
                seatedContext,
                setInventory,
                setContingent,
                setValue
            }}
        >
            {children}
        </SeatedContext.Provider>
    );
}

SeatedContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default function useSeatedContext() {
    const context = React.useContext(SeatedContext);

    if (!context) {
        throw new Error('[useSeatedContext] Did you use useSeatedContext outside a SeatedContextProvider?');
    }

    const { seatedContext, setInventory, setValue, setContingent } = context;

    return [seatedContext, { setInventory, setValue, setContingent }];
}
